const routes = {
  login: "/login",
  homePage: "/",
  about: "/about",
  blog: "/blog",
  product: "/product",
  gallery: "/gallery",
  contact: "/contact",
  materialHandling: "/material_handling_solutions",
  smartStorage: "/smart_storage_solutions",
  smartInventory: "/smart_inventory",
  traceability: "/traceability_solutions",
};

export { routes };
